import React from "react";
import { StatusPill } from "./inventory-ui";
import { formatDate, formatNumber } from "../utils/inventory.utils";

export default function InboundDetailsModal({
  open,
  onClose,
  receipt,
  warehouseName,
}) {
  if (!open || !receipt) return null;

  return (
    <div className="fixed inset-0 z-[999] flex items-center justify-center bg-black/45 p-4">
      <div className="flex max-h-[90vh] w-full max-w-[1050px] flex-col overflow-hidden rounded-[24px] bg-white shadow-2xl">
        <div className="flex items-start justify-between border-b border-[#f4d8dc] px-6 py-5">
          <div>
            <div className="text-[24px] font-bold text-slate-800">
              Inbound Receipt Details
            </div>
            <div className="mt-1 text-[13px] text-slate-500">
              Warehouse: <span className="font-semibold text-slate-700">{warehouseName}</span>
            </div>
            <div className="mt-1 text-[12px] text-slate-400">
              Receipt:{" "}
              {receipt.receiptCode ||
                `INB-${String(receipt.id || "")
                  .replace(/-/g, "")
                  .slice(0, 8)
                  .toUpperCase()}`}
            </div>
          </div>

          <button
            type="button"
            onClick={onClose}
            className="rounded-[12px] border border-[#f2c6cc] px-4 py-2 text-[13px] font-semibold text-[#d86a78] hover:bg-[#fff7f8]"
          >
            Close
          </button>
        </div>

        <div className="min-h-0 flex-1 space-y-5 overflow-y-auto p-6">
          <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
            <div className="rounded-[16px] border border-[#f4dde1] bg-[#fffafb] p-4">
              <div className="text-[11px] font-semibold uppercase tracking-[0.12em] text-slate-400">
                Status
              </div>
              <div className="mt-2">
                <StatusPill value={receipt.status} />
              </div>
            </div>

            <div className="rounded-[16px] border border-[#f4dde1] bg-[#fffafb] p-4">
              <div className="text-[11px] font-semibold uppercase tracking-[0.12em] text-slate-400">
                Created At
              </div>
              <div className="mt-2 text-[14px] font-semibold text-slate-800">
                {formatDate(receipt.createdAt)}
              </div>
            </div>

            <div className="rounded-[16px] border border-[#f4dde1] bg-[#fffafb] p-4">
              <div className="text-[11px] font-semibold uppercase tracking-[0.12em] text-slate-400">
                Items
              </div>
              <div className="mt-2 text-[14px] font-semibold text-slate-800">
                {receipt.items?.length || 0}
              </div>
            </div>

            <div className="rounded-[16px] border border-[#f4dde1] bg-[#fffafb] p-4">
              <div className="text-[11px] font-semibold uppercase tracking-[0.12em] text-slate-400">
                Note
              </div>
              <div className="mt-2 text-[13px] text-slate-700">
                {receipt.note || "-"}
              </div>
            </div>
          </div>

          <div className="max-h-[420px] overflow-auto rounded-[16px] border border-[#f3d6db]">
            <table className="w-full min-w-[980px]">
              <thead className="bg-[#fff7f8] text-left text-[12px] uppercase tracking-[0.12em] text-slate-500">
                <tr>
                  <th className="px-4 py-3">Product</th>
                  <th className="px-4 py-3">Qty</th>
                  <th className="px-4 py-3">UOM</th>
                  <th className="px-4 py-3">Purchase Price</th>
                  <th className="px-4 py-3">Currency</th>
                  <th className="px-4 py-3">Batch No</th>
                  <th className="px-4 py-3">Mfg Date</th>
                  <th className="px-4 py-3">Expiry Date</th>
                </tr>
              </thead>
              <tbody>
                {(receipt.items || []).map((item, index) => (
                  <tr
                    key={`${item.productId || item.id || index}-${index}`}
                    className="border-t border-[#f8dde1] text-[13px] text-slate-700"
                  >
                    <td className="px-4 py-4">
                      <div className="font-semibold text-slate-800">
                        {item.productName || item.name || item.productId || "-"}
                      </div>
                      <div className="text-[12px] text-slate-400">
                        {item.sku || item.productId || "-"}
                      </div>
                    </td>
                    <td className="px-4 py-4">{formatNumber(item.qty)}</td>
<td className="px-4 py-4">{item.uom || "-"}</td>
<td className="px-4 py-4">
  {item.purchasePrice !== null && item.purchasePrice !== undefined && item.purchasePrice !== ""
    ? `₹${formatNumber(item.purchasePrice)}`
    : "-"}
</td>
<td className="px-4 py-4">{item.purchaseCurrency || "INR"}</td>
<td className="px-4 py-4">{item.batchNo || "-"}</td>
                    <td className="px-4 py-4">{formatDate(item.mfgDate)}</td>
                    <td className="px-4 py-4">{formatDate(item.expiryDate)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
}